import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './SimplePage.css';
import ParticleCanvas from '../components/ui/ParticleCanvas';

const TIERS = [
  {
    name: 'Referral Partner',
    icon: '🤝',
    commission: '20% recurring',
    desc: 'Refer businesses to Zepliq and earn 20% of their subscription revenue every month for as long as they stay.',
    perks: ['Unique referral link', 'Real-time dashboard', 'Monthly payouts', 'Marketing materials'],
  },
  {
    name: 'Agency Partner',
    icon: '🏢',
    commission: '30% recurring',
    desc: 'Resell Zepliq to your clients under your brand. Manage all accounts from one dashboard.',
    perks: ['White-label option', 'Dedicated account manager', 'Priority support', 'Co-marketing opportunities'],
    highlight: true,
  },
  {
    name: 'Technology Partner',
    icon: '⚙️',
    commission: 'Custom',
    desc: 'Integrate your platform with Zepliq via our API. List your integration in our marketplace.',
    perks: ['API access', 'Marketplace listing', 'Joint go-to-market', 'Technical support'],
  },
];

export default function PartnersPage() {
  return (
    <div className="simple-page">
      <SEO
        title="Partners — Resell & Integrate with Zepliq WhatsApp Automation"
        description="Partner with Zepliq as a reseller, agency, or technology partner. Earn revenue, access exclusive benefits, and offer your clients best-in-class WhatsApp AI automation."
        keywords="Zepliq partner program, WhatsApp automation reseller, chatbot agency partner, Zepliq affiliate, WhatsApp automation partner, technology partner Zepliq"
        canonical="/partners"
      />

      <section className="simple-hero">
        <ParticleCanvas className="simple-hero__canvas" />
        <div className="simple-hero__blob simple-hero__blob--1" aria-hidden="true" />
        <div className="simple-hero__blob simple-hero__blob--2" aria-hidden="true" />
        <div className="container simple-hero__inner">
          <span className="badge badge-brand">Partners Program</span>
          <h1 className="display-xl simple-hero__title">
            Grow your business<br />
            <span className="gradient-text">with Zepliq.</span>
          </h1>
          <p className="text-lg simple-hero__sub">
            Join our partner ecosystem and earn recurring revenue by helping businesses automate
            their customer conversations with Zepliq.
          </p>
        </div>
      </section>

      <section className="simple-section section">
        <div className="container">

          <div className="simple-header">
            <span className="badge badge-accent">Partner Tiers</span>
            <h2 className="display-lg">Find the right fit for your business</h2>
          </div>

          <div className="simple-grid-3">
            {TIERS.map(tier => (
              <div key={tier.name} className={`simple-card simple-card--tall ${tier.highlight ? 'simple-card--highlight' : ''}`}>
                {tier.highlight && <div className="simple-card__badge">Most Popular</div>}
                <span className="simple-card__emoji">{tier.icon}</span>
                <h3 className="simple-card__title">{tier.name}</h3>
                <div className="simple-card__commission">{tier.commission}</div>
                <p className="simple-card__desc">{tier.desc}</p>
                <ul className="simple-card__list">
                  {tier.perks.map(p => (
                    <li key={p}>
                      <svg width="14" height="14" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="rgba(99,102,241,0.12)"/><path d="M6 10l3 3 5-5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                      {p}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className={`btn btn-lg ${tier.highlight ? 'btn-primary' : 'btn-secondary'}`} style={{ marginTop: 'auto' }}>
                  Apply Now
                </Link>
              </div>
            ))}
          </div>

          <div className="simple-divider" />

          <div className="simple-cta-box">
            <h2 className="display-md">Ready to become a partner?</h2>
            <p className="text-lg">Fill out our partner application and our team will get back to you within 48 hours.</p>
            <div className="simple-cta-actions">
              <Link to="/contact" className="btn btn-primary btn-lg">Apply to Partner Program</Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
